export default {
  name: 'lm-popup',
  props: {
    width: {
      type: String,
      default: 'auto'
    },
    position: {
      type: String,
      default: 'absolute'
    },
    isMask: {
      type: Boolean,
      default: true
    },
    ishasHeader: {
      type: Boolean,
      default: true
    },
    titleText: {
      type: String,
      default: ''
    },
    contentText: {
      type: String,
      default: ''
    },
    cancelText: {
      type: String,
      default: 'Cancel'
    },
    okText: {
      type: String,
      default: 'OK'
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      confirmTitleText: '',
      confirmContentText: '',
      confirmCancelText: '',
      confirmOkText: '',
      // 用于动画处理
      isShow: false,
      tiemr: null
    };
  },
  // v-model 方式 打开或者关闭
  model: {
    prop: 'visible',
    event: 'update'
  },
  methods: {
    handleVisible: function handleVisible(val) {
      // v-model 方式 打开或者关闭
      this.$emit('update', val);
      // .sync 方式 打开或者关闭
      this.$emit('update:visible', val);
    },
    open: function open() {
      this.handleVisible(true);
      this.$emit('opened');
    },
    close: function close() {
      this.handleVisible(false);
      this.$emit('closed');
    },
    cancel: function cancel() {
      this.$emit('cancel');
      this.close();
    },
    // 参照 element api
    /*
    * {
      confirmTitleText = '',
      confirmContentText = '',
      confirmCancelText = '',
      confirmOkText = ''
      }
    */
    $confirm: function $confirm(content) {
      var _this = this;
      Object.keys(content).forEach(function (key) {
        if (_this[key] !== undefined) {
          _this[key] = content[key];
        }
      });
      this.open();
      return new Promise(function (resolve, reject) {
        var okFn = function okFn() {
          return resolve();
        };
        var cancelFn = function cancelFn() {
          return reject();
        };
        // 点击了确认
        _this.$on('ok', okFn);
        // 点击了取消
        _this.$on('closed', cancelFn);
        _this.$on('cancel', cancelFn);
      });
    }
  },
  watch: {
    visible: {
      handler: function handler(val, oldVal) {
        var _this2 = this;
        if (val !== oldVal) {
          clearTimeout(this.tiemr);
          this.tiemr = setTimeout(function () {
            _this2.isShow = val;
          }, 100);
        }
      },
      immediate: true
    }
  }
};